
import { mapMutations, mapActions } from 'vuex'

import TermsAndConditions from '~/components/Member/TermsAndConditions.vue'
import PersonalInformationCollectionAndUse from '~/components/Member/PersonalInformationCollectionAndUse.vue'

import api from '~/api/' // server
import storage, { keys } from '~/services/storage'

export default {
    components: {
        TermsAndConditions,
        PersonalInformationCollectionAndUse,
    },

    data() {
        return {
            id: '',

            password: '',
            passwordConfirm: '',
            nickname: '',

            timeStart: '',
            seconds: 0,
            phone: '',
            certiCode: '',
            isCertiConfirm: null,
            // 20230907 휴대폰번호 인증 시 수정금지
            isCertiConfirm2: null,
            isNotClickCertiRequestErrorMsg: '',

            isCertButton: false,

            snNumber: '',
            // email: '',

            isIdDupCheck: null,
            isPasswordConfirm: null,
            // response: null,

            transShow: true,

            termsShow: false,
            personalInfomationShow: false,

            btnStyleCon: 'disabled', // 인증번호 발송 버튼 스타일 
            btnStyleBlock: 'cursor: not-allowed',
        }
    },
 
    watch: {
        seconds() {
            this.minutes(this.seconds)
        },
        id(val, oldVal) {
            console.log('val, oldVal', val, oldVal)
            // id 입력 변경 시 idDupCheck 초기화
            this.idDupCheck = null
        },
        password(val, oldVal) {
            console.log(
                'this.password, this.passwordConfirm',
                this.password,
                this.passwordConfirm
            )

            if (this.password === this.passwordConfirm) {
                this.isPasswordConfirm = true
            } else {
                this.isPasswordConfirm = false
            }
        },
        passwordConfirm(val, oldVal) {
            console.log(
                'this.password, this.passwordConfirm',
                this.password,
                this.passwordConfirm
            )

            if (this.password === this.passwordConfirm) {
                this.isPasswordConfirm = true
            } else {
                this.isPasswordConfirm = false
            }
        },
        phone(){
            if(this.phone){
                if(this.phone.length === 10 || this.phone.length === 11){
                    this.btnStyleCon = ''
                    this.btnStyleBlock = ''
                } else {
                    this.btnStyleCon = 'disabled'
                    this.btnStyleBlock = 'cursor: not-allowed'
                }
            }
        },
        isIdDupCheck(){

        }
        
    },

    methods: {
        ...mapMutations('member', ['SET_MEMBER_ID', 'SET_SHOW_PAYMENT']),
        ...mapActions('modal', [
            'SHOW_ALERT',
            'SHOW_REGULAR_MEMBER_JOIN',
            'SHOW_REGULAR_MEMBER_WELCOME',
        ]),
        ...mapActions('member', ['GET_MEMBER_INFO']),
        changeIdValue(e, v) {
            const value = e.target.value
            this.id = value
            this.isIdDupCheck = null
        },
        minutes(time) {
            const minutes = Math.floor(time / 60)
            let seconds = time - minutes * 60

            if (seconds < 10) {
                seconds = '0' + seconds
            }

            const converted = minutes + ':' + seconds
            return converted
        },
        // onSubmitAssociate() {
        //     // alert('Form has been submitted!')
        //     if (this.isIdDupCheck === null) {
        //         this.SHOW_ALERT({ content: 'ID 중복 확인필요' })
        //         return
        //     }
        //     if (this.isIdDupCheck === false) {
        //         this.SHOW_ALERT({ content: 'ID 사용 불가능' })
        //         return
        //     }
        //     if (!this.isPasswordConfirm) {
        //         this.SHOW_ALERT({ content: '비밀번호 확인 필요' })
        //         return
        //     }

        //     if (!this.isCertiConfirm) {
        //         this.SHOW_ALERT({ content: '인증번호 확인 필요' })
        //         return
        //     }
        //     if(this.password.length < 8){
        //         this.SHOW_ALERT({ content: '비밀번호 8자 이상 입력' })
        //         return
        //     }

        //     // this.signUpAssociate()
        //     this.signUpRegular()
        // },

        onSubmitRegular() {
            // alert('Form has been submitted!')
            if (this.isIdDupCheck === null) {
                this.SHOW_ALERT({ content: 'ID 중복 확인필요' })
                return
            }
            if (this.isIdDupCheck === false) {
                this.SHOW_ALERT({ content: 'ID 사용 불가능' })
                return
            }
            if (!this.isPasswordConfirm) {
                this.SHOW_ALERT({ content: '비밀번호 확인 필요' })
                return
            }
            if (!this.isCertiConfirm) {
                this.SHOW_ALERT({ content: '인증번호 확인 필요' })
                return
            }
            if (this.nickname.trim().length < 2) {
                this.SHOW_ALERT({ content: '닉네임 2자 이상 입력' })
                return
            }
            if(this.password.length < 8){
                this.SHOW_ALERT({ content: '비밀번호 8자 이상 입력' })
                return
            }

            this.signUpRegular()
        },

        onClickIdDupCheck(v) {
            if (this.isIdDupCheck === true) {
                this.SHOW_ALERT({ content: 'ID 사용 가능' }) 
                return
            }

            console.log('onClickIdDupCheck v', v)
            v.validate('id')

            // 아이디 validation 안되면 중지
            if (v.errors.length > 0) {
                this.isIdDupCheck = false   
                this.SHOW_ALERT({ content: '부적합합 ID입니다.' }) 
                this.id = ''
                return
            }

            if (!this.id) {
                this.isIdDupCheck = false
                return
            }

            this.checkIdDup()
        },
        tickingTimer() {
            if (this.seconds > 0) {
                this.seconds--

                this.timer = setTimeout(() => {
                    this.tickingTimer()
                }, 1000)
            } else {
                clearTimeout(this.timer)
            }
        },
        raiseCertiReqError(error) {
            this.isNotClickCertiRequestErrorMsg = error
            console.log('error=', this.isNotClickCertiRequestErrorMsg)
        },

        // 인증번호 요청
        onClickCertiCodeRequest(v) {
            v.validate('phone')
            // this.$validator
            // console.log('this.$validator', this.$validator)
            // .validate('id')

            // 아이디 validation 안되면 중지
            if (v.errors.length > 0) {
                return
            }

            if (!this.phone) {
                return
            }
            this.certiCode = '';

            if(this.seconds < 120 || this.seconds === 0){
                this.requestCertiCode()
            }
            else{
                this.SHOW_ALERT({ content: '인증번호 재발송은 1분 경과 후 재시도 해주십시오. ' })
            }

            
        },
        // 인증번호 확인
        onClickCertiCodeConfirm(v) {
            if (!this.certiCode) {
                return
            }

            // 아이디 validation 안되면 중지
            if (v.errors.length > 0) {
                return
            }

            this.confirmCertiCode(v)
        },

        /* onClickTrans() {
      this.transShow = !this.transShow
    }, */

        async checkIdDup() {

            if(this.isIdDupCheck !== false){
                const params = {
                    id: this.id,
                }
                const res = await api.checkIdDup(params)

                if (!res) {
                    this.SHOW_ALERT({
                        content: '서버에서 데이터를 불러올 수 없습니다.',
                    })
                    return
                }
                this.isIdDupCheck = res.success
            } 
        },

        // 인증번호 요청
        async requestCertiCode() {
            // 인증번호 입력 reset
            this.certiCode = ''
            // 20230907 휴대폰번호 인증 시 수정금지
            this.isCertiConfirm2 = true
            // 220622 meej 이미 가입돈 휴대폰 번호으로 막기위해 로직 수정
            const params = {
                phone: this.phone,
                reqType: 'new',
            }

            await api.requestCertiCode(params)
                .then((el) => {
                    // 이미 등록된 번호일경우 error메시지 받아와서 보여줌
                    if(!el.success && el.message !== null && el.message !== ''){
                        this.SHOW_ALERT({ content: el.message })
                    }else if(!el.success){
                        this.SHOW_ALERT({
                            content: '서버에서 인증번호를 받아올 수 없습니다.',
                        })
                    }
                    if(el.success){
                        // 요청버튼 눌렀을 때, 시간 할당 후, 타이머 시작
                        this.seconds = 180
                        this.tickingTimer()
                    }
                })
            // const res = await api.requestCertiCode(params)

            // if (res.success) {
            //     // 요청버튼 눌렀을 때, 시간 할당 후, 타이머 시작
            //     this.seconds = 180
            //     this.tickingTimer()
            // } else {
            //     this.SHOW_ALERT({ content: '인증번호 전송 실패' })
            // }
        },
        // 인증번호 확인
        async confirmCertiCode(v) {
            const params = {
                code: this.certiCode,
            }

            const res = await api.confirmCertiCode(params)

            if (res === '') {
                console.log('인증번호 확인 성공!')
                const timerRef = this.$refs.timer
                timerRef.textContent = '인증완료!'
                v.validate('인증번호')
                // timerRef.style.color = 'black'

                // 타이머 해제
                this.isCertiConfirm = true
                clearTimeout(this.timer)
            } else if (!res.success) {
                this.SHOW_ALERT({ content: '인증번호를 다시 확인해주세요!' })
            }

            /**
             * res 값이 없으면 성공
             * 400 에러 나면 실패
             */

            // console.log('confirmCertiCode res', res)
        },

        getMemberInfo(id) {
            const params = {
                id,
                // id: 'testid4', // TEST
            }
            this.GET_MEMBER_INFO(params)
        },

        // async signUpAssociate() {
        //     const params = {
        //         id: this.id,
        //         password: this.$CryptoJS.SHA1(this.password).toString(),
        //         name: this.nickname,
        //         type: 'ASSOCIATE',
        //         phone: this.phone,
        //     }

        //     const res = await api.signUp(params)
        //     console.log('signUp res', res)

        //     // modal 가입완료 표시
        //     if (res.success) {
        //         // 로그인 아이디 store에 저장

        //         // 가입완료 후 성공 시, 바로 로그인 처리
        //         await this.login()

        //         this.SHOW_REGULAR_MEMBER_JOIN({
        //             // 210303 이민수. 가입완료 후, 메인으로 이동 수정
        //             callback: this.$router.push({ path: '/' }),
        //         })
        //     } 
        //     else {
        //         this.SHOW_ALERT({ content: res.message })
        //     }
        // },

        async signUpRegular() {
            const params = {
                id: this.id,
                password: this.$CryptoJS.SHA1(this.password).toString(),
                name: this.nickname,
                type: 'ASSOCIATE',
                phone: this.phone,
            }
            const res = await api.signUp(params)

            // modal 가입완료 표시
            if(res !== undefined){
                if (res.success) {
                    // 로그인 아이디 store에 저장

                    // 가입완료 후 성공 시, 바로 로그인 처리
                    await this.login()

                    this.SET_SHOW_PAYMENT(true)

                    this.SHOW_REGULAR_MEMBER_WELCOME()
                    this.$router.push({ path: '/MyPage/MemberInfo' })
                }
            } else {
                this.SHOW_ALERT({ content: res.message })
            }
        },

        async login() {
            const params = {
                id: this.id,
                password: this.$CryptoJS.SHA1(this.password).toString(),
                // password: this.password,
            }

            console.log('login Params=', params)

            const res = await api.login(params)
            console.log('login res', res)

            // modal 가입완료 표시
            if (res.success) {
                // this.SHOW_ALERT({ content: '로그인 성공' })

                // 로그인 정보(로그인 유지 판단용) 스토리지에 저장
                storage.set(keys.loginInfo, res.data)

                // member store 갱신
                this.getMemberInfo(this.id)

                // id 저장
                if (this.checkedIdSave) {
                    storage.set(keys.id, this.id)
                } else {
                    storage.remove(keys.id)
                }
            }
        },
    },
}
